import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  countByStatus,
  deadlineUrgency,
  formatDateTime,
  normalizeStatus,
  STATUS,
  statusMeta,
  trainingTypeLabel,
} from './homeworkUtils'
import { homeworkPathPrefix } from '../CoursePortal/constants'

export default function TaskOverview({
  homeworks = [],
  userCourses = [],
  courseFilter = 'all',
  statusFilter = 'all',
  keyword = '',
  sortBy = 'path',
  onCourseFilterChange,
  onStatusFilterChange,
  onKeywordChange,
  onSortByChange,
  onSelectHomework,
}) {
  const { t } = useTranslation()
  const counts = countByStatus(homeworks)

  return (
    <div>
      <div className="hwb-filters">
        {userCourses.length > 1 ? (
          <select
            className="hwb-select"
            value={courseFilter}
            onChange={(e) => onCourseFilterChange?.(e.target.value)}
          >
            <option value="all">{t('hw_all_courses', '全部课程')}</option>
            {userCourses.map((course) => (
              <option key={course.id} value={String(course.course_id)}>
                {course.course_name}
              </option>
            ))}
          </select>
        ) : null}
        <input
          className="hwb-search"
          value={keyword}
          onChange={(e) => onKeywordChange?.(e.target.value)}
          placeholder="搜索作业标题或阶段"
        />
        <select
          className="hwb-select"
          value={sortBy}
          onChange={(e) => onSortByChange?.(e.target.value)}
          aria-label="作业排序"
        >
          <option value="path">按路径 / 名称</option>
          <option value="deadline">按截止时间</option>
          <option value="status">按提交状态</option>
        </select>
        <div className="hwb-chip-row">
          {[
            { key: 'all', label: `全部 ${counts.all}` },
            { key: 'pending', label: `待提交 ${counts.pending}` },
            { key: 'submitted', label: `已提交 ${counts.submitted}` },
            { key: 'evaluated', label: `已评价 ${counts.evaluated}` },
          ].map((chip) => (
            <button
              key={chip.key}
              type="button"
              className={`hwb-chip${statusFilter === chip.key ? ' is-active' : ''}`}
              onClick={() => onStatusFilterChange?.(chip.key)}
            >
              {chip.label}
            </button>
          ))}
        </div>
      </div>

      {homeworks.length === 0 ? (
        <div className="hwb-empty">
          {statusFilter === 'all' && !keyword
            ? t('hw_no_homework')
            : '没有符合筛选条件的作业'}
        </div>
      ) : (
        <div className="hwb-task-list">
          {homeworks.map((hw) => {
            const st = normalizeStatus(hw.status)
            const meta = statusMeta(st, t)
            const urgency = deadlineUrgency(hw.deadline)
            const prefix = homeworkPathPrefix(hw, hw.timelineUnit)
            return (
              <button
                key={hw.id}
                type="button"
                className="hwb-task-row"
                onClick={() => onSelectHomework?.(hw)}
              >
                <span className={`hwb-dot ${meta.tone}`} />
                <div className="hwb-task-main">
                  <div className="hwb-task-title-row">
                    {prefix ? (
                      <span className="hwb-path-chip">{prefix}</span>
                    ) : null}
                    <p className="hwb-task-title">{hw.title || hw.Title}</p>
                  </div>
                  <div className="hwb-task-meta">
                    <span>{trainingTypeLabel(hw.trainingType, t)}</span>
                    <span>{formatDateTime(hw.deadline)}</span>
                    {urgency === 'soon' ? <span style={{ color: 'var(--hwb-warn)' }}>即将截止</span> : null}
                    {urgency === 'overdue' ? <span style={{ color: 'var(--hwb-danger)' }}>已过期</span> : null}
                  </div>
                </div>
                <div className="hwb-task-side">
                  {st === STATUS.EVALUATED && hw.teacherScore != null ? (
                    <div className="hwb-task-score">{hw.teacherScore}</div>
                  ) : (
                    <div>{meta.text}</div>
                  )}
                </div>
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
